import { useEffect, useState } from 'react'

type Theme = 'light' | 'dark' | 'system'

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem('kilo.theme') as Theme) || 'system',
  )

  useEffect(() => {
    const root = document.documentElement
    if (theme === 'system') root.removeAttribute('data-theme')
    else root.setAttribute('data-theme', theme)
    localStorage.setItem('kilo.theme', theme)
  }, [theme])

  const next = () => setTheme((t) => (t === 'system' ? 'light' : t === 'light' ? 'dark' : 'system'))
  const label = theme === 'system' ? 'Tema: otomatik' : theme === 'light' ? 'Tema: açık' : 'Tema: koyu'

  return <button onClick={next} title="Temayı değiştir">{label}</button>
}
